// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ea9befa6","703":"8e451e7b","787":"3f85ba94"}[chunkId] + ".chunk.js";
};